import React from "react";

interface PaymentLoadingProps {
  isVisible: boolean;
}

const PaymentLoading: React.FC<PaymentLoadingProps> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 mx-4 max-w-sm w-full text-center">
        {/* 로딩 스피너 */}
        <div className="mb-6">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
        </div>

        {/* 메시지 */}
        <div className="text-lg font-bold text-gray-800 mb-2">
          결제가 진행중이에요
        </div>
        <div className="text-sm text-gray-600">잠시만 기다려주세요!!</div>
      </div>
    </div>
  );
};

export default PaymentLoading;
